import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LargereceiptService } from '../service/largereceipt.service';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { DownloadLargeReceipt, IDownloadLargeReceipt,IDownloadLargeReceiptHF
  ,MessageDetailsResponse,MessageResponse,ResultContent,IMessageDetails } from '../class/largereceipt';
import { SubSink } from 'subsink';
import { AppError } from '../common/class/app-error';
import { TranslationLoaderService } from '../common/translation-loader.service';
import { UserSessionService } from '../common/user-session.service';
import { Message } from '@angular/compiler/src/i18n/i18n_ast';
import { CommonUtilService } from '../service/common-util.service';

@Component({
  selector: 'app-download-large-receipt',
  templateUrl: './download-large-receipt.component.html',
  styleUrls: ['./download-large-receipt.component.scss']
})
export class DownloadLargeReceiptComponent implements OnInit {
  private subs = new SubSink();
  messageId!: string;
  public  resultContentObj=new ResultContent();
  public appLang = '';
  MessageDetailsResponse:string;
  data: any;
  messageDetailsSnapShot:IMessageDetails;
  
  constructor(private largeReceiptService: LargereceiptService,private http: HttpClient,private router:Router, private route: ActivatedRoute
    ,private langLoaderSvc: TranslationLoaderService
    ,private user: UserSessionService
    ,private langSvc: TranslateService
    ,private commonUtilSvc: CommonUtilService
    ) {
    
    this.route.params.subscribe( params => this.messageId=(params.messageId));
    
    localStorage.setItem("MessageId",this.messageId);
    localStorage.removeItem("OriginalUrl");
   }

  ngOnInit(): void {
       
    if(this.route.snapshot.data.messageDetails!=undefined)
    {
      this.messageDetailsSnapShot=this.route.snapshot.data.messageDetails;
      this.resultContentObj=this.messageDetailsSnapShot.ResultContent;
      this.appLang=this.resultContentObj.Language;
    }
    else
    {
      this.appLang='en-us';//default lang
    }

    this.langSvc.setDefaultLang(this.appLang);
    localStorage.setItem('appLang',this.appLang);
    this.InitLang();
    this.commonUtilSvc.hideSpinner();
  }

  

  InitLang() {
    const lang =  this.user.getAppLanguage();
    const browserLang = navigator.language.toLowerCase();
    if (lang === browserLang) {
      this.langLoaderSvc.use(lang);
      this.appLang = lang;
    } else {
      this.langLoaderSvc.use(lang);
      this.appLang = browserLang;
    }
  }

  

  

   GetTodaysDate() {
    var x = new Date();
    var y = x.getFullYear().toString();
    var m = (x.getMonth() + 1).toString();
    var d = x.getDate().toString();
    (d.length == 1) && (d = '0' + d);
    (m.length == 1) && (m = '0' + m);
    var yyyymmdd = y + m + d;
    return yyyymmdd;
}

  DownloadLargeReceipt()
  {
    /* this.commonUtilSvc.showSpinner();
    window.location.href=this.largeReceiptService.downloadLargeReceiptsByUrl(this.messageId);
    this.commonUtilSvc.hideSpinner(); */
    $("#divDownloading").css("display","block");
    window.location.href=this.largeReceiptService.downloadLargeReceiptsByUrl(this.messageId);
    const date = new Date();
    date.setSeconds( date.getSeconds() + 20 );
    document.cookie = "fileDwnld"+"="+1+"; expires="+date+"; path=/";
    this.commonUtilSvc.setCookie('fileDwnld');
  }


  DownloadLargeReceiptOld()
  {
    //alert(this.commonUtilSvc.GetBrowserName());
    this.commonUtilSvc.showSpinner();
    this.subs.sink = this.largeReceiptService.downloadLargeReceipts(this.messageId)
    .subscribe(data => {
      if (!(data instanceof AppError)) {      
         
         
         const blob = new Blob([data], {
          type: 'application/zip',  
          
        });

        var a = document.createElement("a");
      document.body.appendChild(a);
      
        
        let fileName="Receipt_"+this.messageId+"_"+ this.GetTodaysDate()+".zip";
        //if it is IE
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          
          window.navigator.msSaveOrOpenBlob(blob, fileName);
      } 
        else
        {
           
          let browserName=this.commonUtilSvc.GetBrowserName()
          let isItMobileDevice= this.commonUtilSvc.IsMobileDevice();
          
          if(isItMobileDevice && (browserName=='chrome' || browserName=='safari'))
          {
            // true for mobile device
            //window.location.href=this.largeReceiptService.downloadLargeReceipts1(this.messageId);
          }
          else{
            // false for not mobile device
            const url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = fileName;
            a.click();
            //window.URL.revokeObjectURL(url);
            setTimeout(function(){
              // For Firefox it is necessary to delay revoking the ObjectURL
              window.URL.revokeObjectURL(url);
            }, 100);

          }
          
        
        }

        //window.open(url);
        this.commonUtilSvc.hideSpinner();
      }
      
    });
    

   
  }


}
